import { gql } from '@urql/core';

import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';
import { globalFeatureKeys } from '../_global/queries';

export const enableSiteMutation = ({ client, queryClient }) => ({
  mutationFn: ({ siteId, enable }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation SiteEnableAnalytics($siteId: Int!, $enable: Boolean!) {
          siteEnableAnalytics(siteId: $siteId, enable: $enable) {
            id
            webAnalyticsEnabled
          }
        }
      `,
      {
        siteId,
        enable,
      },
    ),
  onSuccess: () => {
    queryClient.invalidateQueries({ ...globalFeatureKeys.me });
    return queryClient.invalidateQueries({ queryKey: ['sites'] });
  },
});
